import { render } from "./PeriodenSignalZuschussEingabe.pug?vue&type=template&id=d8c6e30a&lang=pug"
import script from "./PeriodenSignalZuschussEingabe.js?vue&type=script&lang=js"
export * from "./PeriodenSignalZuschussEingabe.js?vue&type=script&lang=js"

import "./PeriodenSignalZuschussEingabe.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__